import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const EndOfTrialPage = lazy(() => import('.'))

class EndOfTrialPageWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['is-biller']
	}

	override render() {
		const isBiller = Boolean(this.jsonProp<boolean>('is-biller')) ?? false

		return (
			<PageRoot>
				<EndOfTrialPage isBiller={isBiller} />
			</PageRoot>
		)
	}
}

customElements.define('end-of-trial-page', EndOfTrialPageWebComponent)
